import React, { useMemo } from 'react';
import { ScommesseLeafItem, ScommesseLeafItemProps, ScommesseLeafItemType } from 'components/scommesseTipo/components/cells';

import { EsitoListItem } from 'components/scommesseTipo/components/scommesseQuoteList/EsitoListItem';
import { InfoAggiuntivaListItem } from 'components/scommesseTipo/components/scommesseQuoteList/InfoAggiuntivaListItem';
import { InfoAggiuntivaWithEsitoListItem } from 'components/scommesseTipo/components/scommesseQuoteList/InfoAggiuntivaWithEsitoListItem';
import { ItemWithTranslation } from 'types/swagger';
import { QuotaListItem } from 'components/scommesseTipo/components/scommesseQuoteList/QuotaListItem';

export { ScommesseQuoteList } from './ScommesseQuoteList';

export type ScommesseQuoteListProps = ItemWithTranslation<{ tipoScommessa?: Array<string> }> & {
  type: ScommesseLeafItemType;
  headerList: Array<string | undefined>;
  optionsKeys: Array<string>;
  scommessaKey: string;
  bilanciataKey?: string;
  infoAggiuntivaKey: string;
  selectedOptionKey?: string;
  setIsOpen: (_: boolean) => void;
  onOptionSelected: (_: string) => void;
};

export type ScommesseQuoteListItemProps = ScommesseLeafItemProps & {
  disabled?: boolean;
  isSelected: boolean;
  isBilanciata: boolean;
  onClick: (_: string) => void;
};

export type ScommesseListItemProps = ScommesseQuoteListItemProps & {
  type: ScommesseLeafItemType;
};

export const ScommesseListItem = ({ type, ...oth }: ScommesseListItemProps) => {
  const Item = useMemo(() => {
    switch (type) {
      case ScommesseLeafItem.Esito: {
        return EsitoListItem;
      }
      case ScommesseLeafItem.Quota: {
        return QuotaListItem;
      }
      case ScommesseLeafItem.MarcatoriInfoAgg:
      case ScommesseLeafItem.InfoAggiuntiva: {
        return InfoAggiuntivaListItem;
      }
      case ScommesseLeafItem.InfoAggiuntivaWithEsito: {
        return InfoAggiuntivaWithEsitoListItem;
      }
      default: {
        throw new Error(`ScommesseListItem: unmanaged option ${type}`);
      }
    }
  }, [type]);

  return <Item {...oth} />;
};